import { styled } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

export const AcceptIcon = styled(CheckIcon)(({ theme }) => ({
    fontSize: 20,
    color: theme.palette.grey[500],
}));
